import { Suspense, lazy, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import { nativeService } from '@bluecodecom/native';

import { sessionService } from '@bluecodecom/pay-at-pump-webview/features/session';
import { trackingService } from '@bluecodecom/pay-at-pump-webview/features/tracking';

import './i18n';

const App = lazy(() => import('./app'));

const Main = () => {
  useEffect(() => {
    nativeService.hideNavigation();
    nativeService.allowResumeMiniApp();

    trackingService.provider = sessionService.provider;
    trackingService.trackEvent('Opened');
  }, []);

  useEffect(() => {
    // The native navigation can come back when the webview is backgrounded
    // and resumed. With the sheet UX the app has no close button of its own,
    // so it must not be left with the host's either — or with both.
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        nativeService.hideNavigation();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <LoaderProvider>
      <ThemeProvider observe>
        <Suspense>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Suspense>
      </ThemeProvider>
    </LoaderProvider>
  );
};

createRoot(document.getElementById('root') as HTMLElement).render(<Main />);
